import { MicroviewCommunicationChannel } from '../MicroviewCommunicationChannel';

export enum EPTSessionType {
  contentSuggestion = 'contentSuggestion',
  fullSearch = 'fullSearch',
}

export enum EPTTimestampType {
  start = 'start',
  initialUIRendered = 'initialUIRendered',
  sendingRequestsToServerSide = 'sendingRequestsToServerSide',
  gotResponseFromServerSide = 'gotResponseFromServerSide',
  end = 'end',
}

export class SearchEPTStartChannel extends MicroviewCommunicationChannel<{ type: EPTSessionType; key: string }, void> {
  public name: string = 'SearchEPTStartChannel';
  public namespace: string = 'SearchEPT';
}

export class SearchEPTEndChannel extends MicroviewCommunicationChannel<
  { type: EPTSessionType; key: string; clientRequestID?: string },
  void
> {
  public name: string = 'SearchEPTEndChannel';
  public namespace: string = 'SearchEPT';
}

export class SearchEPTMarkChannel extends MicroviewCommunicationChannel<
  { type: EPTSessionType; key: string; timestampType: EPTTimestampType },
  void
> {
  public name: string = 'SearchEPTMarkChannel';
  public namespace: string = 'SearchEPT';
}
